import React,{useEffect} from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

// home page components import start
import HomeBanner from '../components/home/HomeBanner';
import WhoWeAre from '../components/home/WhoWeAre';
import WhatWeOffer from '../components/home/WhatWeOffer';
import WhyChooseUs from '../components/home/WhyChooseUs';
import ContactUs from '../components/ContactUs';
// home page components import end

import GallerySlider from '../components/GallerySlider';
import VideoTestimonials from '../components/VideoTestimonials';
import PaymentMethods from '../components/PaymentMethods';
import CookiesPopup from '../components/CookiesPopup';
import WhatsappChat from '../components/WhatsappChat';
import ScrollTop from '../components/ScrollTop';
import ContactIcon from '../components/ContactIcon';

import Title from "../components/Title";

const Home = () => {
      useEffect(() => {
            window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: "instant"
              });
          }, []);
        return(
            <>
              <Title title="CAD AND RENDER" />
              <Header />

              <HomeBanner />
              <CookiesPopup />
              <ContactIcon />
              <WhatsappChat />
              <ScrollTop />

              <WhoWeAre />
              <WhatWeOffer />
              <WhyChooseUs />
              <GallerySlider />
              <ContactUs />

              <VideoTestimonials />
              <PaymentMethods />
              
              <Footer />
              </>  
        )
}



export default Home;